<div class="koppelingMenu">
  <span *ngFor="let menu_item of (viewModel.onGetMenuItems | async)">
    <div [class]="menuItemClass(menu_item)" (click)="switchMenuItem(menu_item.key)">
      <p class="bodyContentSemi"> {{menu_item.caption}} </p>
    </div>
  </span>
</div>
